import { memo, useRef } from 'react';
import ArrowAnimation, { ArrowDirection } from './ArrowAnimation';
import GlowAnimation from './GlowAnimation';

interface IconProps {
  className?: string;
}

function SunriseIcon({ className }: IconProps) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  return (
    <svg
      ref={svgRef}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-test="weather-icon-sunrise"
    >
      <path
        d="M51.5515 37.0457C50.7898 36.2458 50.821 34.9803 51.6209 34.2185L58.6209 27.5515C59.3932 26.8161 60.6063 26.8161 61.3787 27.5515L68.3787 34.2185C69.1785 34.9803 69.2098 36.2458 68.448 37.0457C67.6864 37.8454 66.4208 37.8764 65.6209 37.115L61.9998 33.6658L61.9998 42.9998C61.9998 44.1043 61.1044 44.9998 59.9998 44.9998C58.8952 44.9998 57.9998 44.1043 57.9998 42.9998L57.9998 33.6658L54.3787 37.115C53.5788 37.8764 52.3132 37.8454 51.5515 37.0457Z"
        fill="white"
      >
        <ArrowAnimation direction={ArrowDirection.Up} />
      </path>
      <g filter="url(#filter0_d_sunrise)">
        <path
          d="M60 51.9998C74.9117 51.9998 87 64.0881 87 78.9998C87 83.3106 85.9881 87.3847 84.1914 90.9998H35.8086C34.0119 87.3847 33 83.3106 33 78.9998C33 64.0881 45.0883 51.9998 60 51.9998Z"
          fill="#FFA51F"
        />
      </g>
      <path
        d="M96 88.9998C97.1046 88.9998 98 89.8952 98 90.9998C98 92.1043 97.1046 92.9998 96 92.9998H24C22.8954 92.9998 22 92.1043 22 90.9998C22 89.8952 22.8954 88.9998 24 88.9998H96Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_sunrise"
          x="17"
          y="35.9998"
          width="86"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8">
            <GlowAnimation />
          </feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.852175 0 0 0 0 0.63208 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default memo(SunriseIcon);
